//TODO: Implement ChatComponent

import { useGetChatSchema } from '../../Chat/hooks'
import { ChatContent } from './ChatContent'

export const ChatComponent = ({ id }: { id: string }) => {
  // const { tileFilterSelections } = useTileFilters()
  const { data } = useGetChatSchema({ contentId: id })

  return (
    <ChatContent
      uiSchema={data.uiSchema}
      // tileFilters={<TileFilter schema={data.filters}  />}
    />
  )
}

export function ChatComponentLoading() {
  return 'Loading...'
}
